import styled from 'styled-components'
import { AmorinWiseBackground, WicanderBackground } from '../../../assets'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const AmorimWise = styled.div`
  position: relative;
  width: 100%;
  height: 50%;
  transition: all .6s cubic-bezier(0.59,-0.01, 0.29, 0.96);
  background: url(${AmorinWiseBackground}) no-repeat;
  background-position: 0 -100px;
  background-size: cover;

  :after {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    background-color: rgba(29, 55, 57, 0.8);
    transition: all .6s cubic-bezier(0.59,-0.01, 0.29, 0.96);
  }

  :before {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 30%;
    z-index: 1;
    pointer-events: none;
    opacity: 1;
    background-image: linear-gradient(180deg, rgba(0,0,0,.7), transparent);
    transition: all .6s cubic-bezier(0.59,-0.01, 0.29, 0.96);
  }

  &.stretch {
    height: 60%;
    background-position: 0 -120px;

    :after {
      background-color: rgba(29, 55, 57, .65);
    }
  }

  &.shrink {
    height: 40%;
    background-position: 0 -120px;
  }
`

export const Wicanders = styled.div`
  position: relative;
  width: 100%;
  height: 50%;
  transition: all .6s cubic-bezier(0.59,-0.01, 0.29, 0.96);
  background: url(${WicanderBackground}) no-repeat;
  background-position: center center;
  background-size: cover;

  :before {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 30%;
    z-index: 1;
    pointer-events: none;
    opacity: 1;
    background-image: linear-gradient(180deg, rgba(0,0,0,.7), transparent);
    transition: all .6s cubic-bezier(0.59,-0.01, 0.29, 0.96);
  }

  :after {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    background-color: rgba(29, 55, 57, 0.8);
    transition: all .6s cubic-bezier(0.59,-0.01, 0.29, 0.96);
  }

  &.stretch {
    height: 60%;
    background-position: center center;
    :after {
      background-color: rgba(29, 55, 57, .65);
    }
    :before {
      opacity: .5;
    }
  }

  &.shrink {
    height: 40%;
    background-position: center center;
  }
`

export const ContainerContent = styled.div`
  position: absolute;
  left: 20px;
  bottom: 22px;
  width: auto;
  min-height: 180px;
  z-index: 2;

  &.content-right {
    left: initial;
    right: 20px;
  }
`

export const Text = styled.p`
  font-family: 'Amorim Sans Book', sans-serif;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: .9px;
  color: #FFF;
  margin: 0;

  &.smaller-text {
    font-size: 18px;
  }

  &.text-right {
    text-align: right;
  }
`

export const BigText = styled.div`
  width: ${p => p.width}px;
  height: 28px;
  margin: 0;
  margin-top: 40px;
  background: url(${p => p.src}) no-repeat;
  background-size: contain;

  &.pos-right {
    position: relative;
    right: -28px;
  }
`

export const ButtonStartVisit = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Amorim Sans Book', sans-serif;
  font-size: 18px;
  letter-spacing: .9px;
  color: #FFF;
  width: 180px;
  height: 40px;

  &.content-right {
    margin-left: auto;
    width: 120px;
    text-align: right;
  }
`

export const Arrow = styled.div`
  width: 30px;
  height: 10px;
  mask: url(${p => p.background}) no-repeat;
  background: #FFF;
  margin-left: 10px;
  transition: all .2s ease-out;

  &.content-right {
    margin-left: 0;
    mask-position: 12px 0;
  }
`